export interface CrossTabMessage {
  type: CrossTabMessageType;
  payload?: unknown;
  timestamp: number;
  tabId: string;
}

export enum CrossTabMessageType {
  TOKEN_REFRESH_START = "TOKEN_REFRESH_START",
  TOKEN_REFRESH_SUCCESS = "TOKEN_REFRESH_SUCCESS",
  TOKEN_REFRESH_FAILURE = "TOKEN_REFRESH_FAILURE",
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  TOKEN_UPDATED = "TOKEN_UPDATED",
}

export interface TokenRefreshSuccessPayload {
  accessToken: string;
  refreshToken?: string;
}

export interface LoginPayload {
  accessToken: string;
  refreshToken?: string;
  user?: unknown;
}

export interface AuthSyncCallbacks {
  onLogin?: (payload: LoginPayload) => void;
  onLogout?: () => void;
  onTokenUpdate?: (payload: TokenRefreshSuccessPayload) => void;
}

export interface CrossTabConfig {
  enabled?: boolean;
  channelName?: string;
  lockName?: string;
  lockTimeout?: number;
  storageKey?: string;
}

export interface CrossTabSync {
  initialize(config?: CrossTabConfig): void;
  destroy(): void;
  broadcast(message: Omit<CrossTabMessage, "timestamp" | "tabId">): void;
  onMessage(callback: (message: CrossTabMessage) => void): () => void;
  withLock<T>(callback: () => Promise<T>): Promise<T>;
  isRefreshingInOtherTab(): boolean;
  notifyTokenUpdate(tokens: TokenRefreshSuccessPayload): void;
  notifyLogin(payload: LoginPayload): void;
  notifyLogout(): void;
  subscribeToAuthEvents(callbacks: AuthSyncCallbacks): () => void;
  isSupported(): boolean;
}

export const DEFAULT_CROSS_TAB_CONFIG: Required<CrossTabConfig> = {
  enabled: true,
  channelName: "oneapp-auth",
  lockName: "oneapp-token-refresh",
  lockTimeout: 10000,
  storageKey: "oneapp-auth-sync",
};
